export const ROOT_PADDING = {
  PC: 32,
  SP: 16,
} as const;
